<template>
  <div v-if="entries.length" class="listing-links" :class="{ compact }">
    <a
      v-for="entry in entries"
      :key="entry.key"
      :href="entry.url"
      target="_blank"
      rel="noopener noreferrer"
      :class="['listing-link', `listing-link--${entry.kind}`]"
      :title="entry.title"
      @click.stop
      >{{ entry.text }}<span aria-hidden="true"> ↗</span></a
    >
  </div>
</template>

<script>
import { computed } from "vue";

// Links of a listing computed by the API from the user's settings
// ("Réglages > Sources et achat"): links = { view, buy, origin }, each
// { url, label, via } where via is "origin" (the site) or an intermediary.
export default {
  name: "ListingLinks",
  props: {
    links: { type: Object, default: null },
    // Text links (cards) instead of buttons (panels)
    compact: { type: Boolean, default: false },
  },
  setup(props) {
    const entries = computed(() => {
      const { view, buy, origin } = props.links || {};
      const list = [];
      const onSite = (link) => link.via === "origin";
      if (view && buy && view.url === buy.url) {
        list.push({
          key: "open",
          kind: "primary",
          url: buy.url,
          text: props.compact ? "Ouvrir" : `Ouvrir sur ${buy.label}`,
          title: `Consulter et acheter sur ${buy.label}`,
        });
      } else {
        if (buy)
          list.push({
            key: "buy",
            kind: "primary",
            url: buy.url,
            text: props.compact
              ? "Acheter"
              : `Acheter ${onSite(buy) ? "sur" : "via"} ${buy.label}`,
            title: `Acheter ${onSite(buy) ? "sur" : "via"} ${buy.label}`,
          });
        if (view)
          list.push({
            key: "view",
            kind: "secondary",
            url: view.url,
            text: props.compact ? "Voir" : `Voir sur ${view.label}`,
            title: `Consulter sur ${view.label}`,
          });
      }
      if (origin && !list.some((entry) => entry.url === origin.url))
        list.push({
          key: "origin",
          kind: "muted",
          url: origin.url,
          text: "Page d’origine",
          title: `Annonce sur ${origin.label}`,
        });
      return list;
    });
    return { entries };
  },
};
</script>

<style scoped>
.listing-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.listing-link {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}
.listing-link span {
  margin-left: 3px;
}
.listing-link--primary {
  border-color: #168a64;
  background: #168a64;
  color: #fff;
}
.listing-link--primary:hover {
  background: #127555;
}
.listing-link--secondary {
  border-color: #cfd6df;
  background: #fff;
  color: #4e596a;
}
.listing-link--secondary:hover {
  background: #f5f7fa;
}
.listing-link--muted {
  min-height: auto;
  padding: 0 4px;
  border: 0;
  background: none;
  color: #6f7b8d;
  font-weight: 600;
}
/* Cards: plain text links */
.compact {
  gap: 14px;
}
.compact .listing-link {
  min-height: auto;
  padding: 0;
  border: 0;
  background: none;
  font-size: 13px;
}
.compact .listing-link--primary {
  color: #168a64;
}
.compact .listing-link--secondary {
  color: #2e6098;
}
</style>
